module.exports = __webpack_public_path__ + "img/49.8.TSS.59e0e90e.png";